import styled from "styled-components";

export const Icon = styled.img`
  width: ${props => props.width || 24}px;
  height: ${props => props.height || 24}px;
  margin-top: ${props => props.style?.marginTop || -2}px;
  // margin-right: ${props => props.style?.marginRight || 5}px;
`;